// extracted by mini-css-extract-plugin
module.exports = {"chipWrapper":"_3lWqak","highlight":"_3ManeB"};